import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const App: React.FC = () => (
  <Result
    status="404"
    title="您访问的页面不存在"
    subTitle="抱歉，您所访问的页面不存在，请尝试其它的链接地址，或回到首页. 若您认为这是一个系统问题，请联系系统管理员并描述您遇到的问题详情"
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        返回首页
      </Button>
    }
  />
);

export default App;
